export default __webpack_public_path__ + "static/media/services.d1ff6f94.svg";